import { Controller } from "@hotwired/stimulus"
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper"
import ahoy from 'ahoy.js'
import Rails from '@rails/ujs'

// Connects to data-controller="zebra-print"
export default class extends Controller {
  connect() {
    this.element.addEventListener("click", () => this.print())
  }

  async print() {
    try {
      const selector = this.element.dataset.zebraPrintTarget
      const container = document.querySelector(selector)
      if (!container) {
        alert(`No container found for selector: ${selector}`)
        return
      }

      const elements = container.querySelectorAll("[data-zpl]")
      if (elements.length === 0) {
        alert("No data-zpl elements found in container")
        return
      }

      let printDetails = {}
      const zpl = Array.from(elements).map(el => {
        const baseZpl = el.dataset.zpl
        const btnQty = parseInt(this.element.dataset.qty, 10)
        const recQty = parseInt(el.dataset.recQty, 10)
        const input = el.querySelector("input")
        let count = btnQty
        if ( !btnQty && input ) {
          count = parseInt(input.value, 10) || recQty
        } else if (!btnQty) {
          count = recQty
        }
        printDetails[el.dataset.inventoryGroupId] = count

        return Array(count).fill(baseZpl).join("\n")
      }).join("\n")

      ahoy.track("Receiving Print", printDetails)

      const browserPrint = new ZebraBrowserPrintWrapper()
      const defaultPrinter = await browserPrint.getDefaultPrinter()
      browserPrint.setPrinter(defaultPrinter)

      const status = await browserPrint.checkPrinterStatus()
      if (status.isReadyToPrint) {
        await browserPrint.print(zpl)
        this.markAsPrinted()
      } else {
        alert("Printer not ready:", status.errors)
      }
    } catch (error) {
      alert("Zebra print error:", error)
    }
  }

  markAsPrinted() {
    const selector = this.element.dataset.zebraPrintMarkPrintedSelector
    if (!selector) return

    const form = document.querySelector(selector)?.closest("form")
    if (form) Rails.fire(form, "submit")
  }
}